import { SolarDate } from "@nghiavuive/lunar_date_vi";

export function convertLunaDate(solarDate: Date) {
  const solar = new SolarDate(solarDate);
  const lunar = solar.toLunarDate();

  const lunarUTC = new Date(
    Date.UTC(lunar.get().year, lunar.get().month - 1, lunar.get().day)
  );
  return { solar, lunar, lunarUTC };
}
